import { render, staticRenderFns } from "./ListAllReports.vue?vue&type=template&id=0c6ccf6a&scoped=true&lang=pug&"
import script from "./ListAllReports.vue?vue&type=script&lang=ts&"
export * from "./ListAllReports.vue?vue&type=script&lang=ts&"
import style0 from "./ListAllReports.vue?vue&type=style&index=0&id=0c6ccf6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ccf6a",
  null
  
)

export default component.exports